<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-underline`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M39 40a1 1 0 011 1v2a1 1 0 01-1 1H9a1 1 0 01-1-1v-2a1 1 0 011-1h30zM13 5a1 1 0 011 1v16c0 5.523 4.477 10 10 10s10-4.477 10-10V6a1 1 0 011-1h2a1 1 0 011 1v16c0 7.732-6.268 14-14 14s-14-6.268-14-14V6a1 1 0 011-1h2z"/></svg>
</template>
<script>

export default {
  name: 'IconUnderline',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
